import { useCallback, useEffect, useState } from 'react';

/**
 * هوک ذخیره و بازیابی مقدار از localStorage با همگام‌سازی بین تب‌ها.
 * @template T
 * @param {string} key کلید ذخیره
 * @param {T} initialValue مقدار اولیه
 */
export const useLocalStorage = (key, initialValue) => {
  const readValue = useCallback(() => {
    if (typeof window === 'undefined') return initialValue;
    try {
      const item = window.localStorage.getItem(key);
      return item !== null ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn(`useLocalStorage: خواندن کلید "${key}" با خطا مواجه شد`, error);
      return initialValue;
    }
  }, [key, initialValue]);

  const [storedValue, setStoredValue] = useState(readValue);

  const setValue = useCallback(
    (value) => {
      try {
        const valueToStore = value instanceof Function ? value(storedValue) : value;
        setStoredValue(valueToStore);
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
        window.dispatchEvent(new StorageEvent('storage', { key }));
      } catch (error) {
        console.warn(`useLocalStorage: نوشتن کلید "${key}" با خطا مواجه شد`, error);
      }
    },
    [key, storedValue],
  );

  useEffect(() => {
    const handler = (e) => {
      if (e.key && e.key !== key) return;
      setStoredValue(readValue());
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, [key, readValue]);

  return [storedValue, setValue];
};
